import { useState } from 'react';
import { usePageContext } from '../../../../providers/PageProvider';
import { ProposalSidebar } from './components/ProposalSidebar';
import { TranscriptViewer } from './components/TranscriptViewer';
import { ResponsivePanels } from '@components/ResponsivePanels';

export const Workspace = () => {
  const [activePanel, setActivePanel] = useState<'first' | 'second'>('first');
  const { session } = usePageContext();

  if (!session) {
    return null;
  }

  return (
    <ResponsivePanels
      activePanel={activePanel}
      onPanelChange={setActivePanel}
      firstLabel="Transcript"
      secondLabel="Proposals"
      first={<TranscriptViewer />}
      second={<ProposalSidebar onRevealTranscript={() => setActivePanel('first')} />}
      className="xl:grid-cols-[minmax(0,1fr)_460px]"
    />
  );
};
